<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="sf_amount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sf_amount || "金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sf_amount"
              placeholder="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="sf_remark">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.sf_remark || '备注'"
              rows="3"
              v-model="form.main.sf_remark"
              maxlength="100"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.sf_remark ? form.main.sf_remark.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/sale/servefee",
      codeField: "sf_code",
      caller: "ServeFee",
      xtype: "make-servefee-formpanel",
      form: {
        main: {

        },
        items: [
          {

          }
        ],
      },
    };
  },
  methods: {
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main
      if (!main.sf_amount) {
        me.$weui.topTips("请填写金额", 2000);
      } else {
        me.p_save();
      }
    },
    p_save() {
      const me = this

      me.$loading({
        url: "/api/sale/servefee/save?caller=ServeFee",
        method: "POST",
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.$router.back()
        }
      })
    }
  }
};
</script>